export enum AccountLogType {
    PASSWORD_UPDATE = 1,
    FORGOT_PASSWORD_UPDATE = 2,
    EMAIL_UPDATE = 3,
    NAME_UPDATE = 4,
    SESSION_CREATE = 5,
    SESSION_UPDATE = 6,
    WORK_UPDATE = 7,
    OFFER_CB_DELETE = 8,
    OFFER_SCHEDULED_CANCEL = 9,
    ADDRESS_UPDATE = 10,
    OFFER_SCHEDULE_CREATE = 11,
    OFFER_CONFIRMED_CREATE = 12,
    PHONE_UPDATE = 13,
    ACCOUNT_CREATE = 14,
    OFFER_QUOTE_CREATE = 15,
    OFFER_QUOTE_DELETE = 16,
    COMMUNITY_CREATE = 17,
    COMMUNITY_ARTICLE_AI_PROPOSALS = 18,
    COMMUNITY_ARTICLE_AI_SECTIONS = 19,
    COMMUNITY_ARTICLE_AI_GENERATION = 20,
    COMMUNITY_ARTICLE_AI_TRANSFERRED = 21,
    COMMUNITY_SITE_CHANNEL = 22,
    COMMUNITY_ENABLED_AUTO_BLOG = 23,
    COMMUNITY_DISABLED_AUTO_BLOG = 24,
    COMMUNITY_AUTO_BLOG_PREPARE_DNS = 25,
    COMMUNITY_AUTO_BLOG_VALIDATE_DNS = 26,
    COMMUNITY_ARTICLE_DELETE = 27,
    COMMUNITY_CATEGORY_CREATE = 28,
    COMMUNITY_CATEGORY_DELETE = 29,
    COMMUNITY_SETTINGS_UPDATE = 30,
    COMMUNITY_APPEARANCE_UPDATE = 31,
    COMMUNITY_LINK_UPDATE = 32,
    COMMUNITY_LOGO_UPDATE = 33,
    EMAIL_SEND = 34,
    OFFER_SCHEDULE_DELETE = 35,
    COMMUNITY_CONTEXT_UPDATE = 36,
    COMMUNITY_ARTICLE_AI_PROPOSALS_AUTOPILOT = 37,
    COMMUNITY_ARTICLE_WRITING_STYLE_CREATE = 38,
    COMMUNITY_ARTICLE_WRITING_STYLE_DELETE = 39,
    COMMUNITY_AUTOPILOT_UPDATE = 40,
    COMMUNITY_AUTOPILOT_DISABLE = 41,
    OFFER_ESTIMATE_DATE_CANCEL = 42,
    COMMUNITY_ONBOARDING_STEP_1_VALIDATE = 43,
    COMMUNITY_ONBOARDING_STEP_2_VALIDATE = 44,
    COMMUNITY_ONBOARDING_STEP_2_SKIP = 45,
    COMMUNITY_ONBOARDING_STEP_3_VALIDATE = 46,
    OFFER_CLOSED = 47,
    COMMUNITY_ADD_REDACTOR = 48,
    COMMUNITY_REMOVE_REDACTOR = 49,
    COMMUNITY_ARTICLE_AI_SECTIONS_UPDATE = 50,
    COMMUNITY_ARTICLE_AI_FINISH = 51,
    COMMUNITY_ARTICLE_AI_SERP_CREATE = 52,
    COMMUNITY_ARTICLE_AI_CREATE = 53,
    COMMUNITY_ARTICLE_AI_STEP_KEYWORD_VALIDATE = 54,
    COMMUNITY_ARTICLE_AI_STEP_RULES_VALIDATE = 55,
    COMMUNITY_ARTICLE_AI_REVISED = 56,
    COMMUNITY_ARTICLE_AI_REVISED_ERROR = 57,
    COMMUNITY_RANKING_OVERVIEW_CREATE = 58,
    COMMUNITY_RANKING_DELETE = 59,
    COMMUNITY_DELETE = 60,
    SITE_CREATE = 61,
    COMMUNITY_KEYWORDS_SEARCH = 62,
    OFFER_ENABLED = 63,
    COMMUNITY_CLUSTER_KEYWORDS_CREATE = 64,
    COMMUNITY_CLUSTER_KEYWORDS_UPDATE = 65,
    COMMUNITY_CLUSTER_KEYWORDS_COMPETITORS = 66,
    COMMUNITY_ARTICLE_AI_TRANSFERRED_ERROR = 67,
    COMMUNITY_KEYWORDS_SITE = 68,
    COMMUNITY_KNOWLEDGE_BASE_CREATE = 69,
    COMMUNITY_KNOWLEDGE_BASE_UPDATE = 70,
    COMMUNITY_KNOWLEDGE_BASE_DELETE = 71,
    COMMUNITY_KNOWLEDGE_RESSOURCE_CREATE = 72,
    COMMUNITY_KNOWLEDGE_RESSOURCE_FILE_CREATE = 73,
    COMMUNITY_KNOWLEDGE_RESSOURCE_DELETE = 74,
    COMMUNITY_SEND_EMAIL_NOTIFICATION_RANKING = 75,
    COMMUNITY_RANKING_COMPARATIVE_CREATE = 76,
    COMMUNITY_RANKING_INDIVIDUAL_CREATE = 77,
    COMMUNITY_CLUSTER_KEYWORDS_DELETE = 78,
    COMMUNITY_ARTICLE_AI_PUBLISHED = 79,
    COMMUNITY_GSC_CONNECTED = 80,
    COMMUNITY_GSC_SITE_NOT_MATCHED = 81,
    COMMUNITY_GSC_SITE_VERIFICATION = 82,
    COMMUNITY_GSC_DISCONNECT = 83,
    COMMUNITY_GSC_NO_PERMISSIONS = 84,
    COMMUNITY_ARTICLE_AI_GENERATION_ERROR = 85,
    COMMUNITY_ARTICLE_AI_AUTOPILOT_ERROR = 86,
    COMMUNITY_ARTICLE_AI_AUTOPILOT_PAYMENT_REQUIRED = 87,
    COMMUNITY_ARTICLE_AI_AUTOPILOT_NO_ARTICLES_DATA = 88,
    COMMUNITY_AUTOPILOT_ADD_CLUSTER = 89,
    COMMUNITY_AUTOPILOT_REMOVE_CLUSTER = 90,
    COMMUNITY_ARTICLE_AI_BRIEF_STEP_SELECT_TERMS_VALIDATE = 91,
    COMMUNITY_IMPORT_CONTENT = 92,
    COMMUNITY_ARTICLE_AI_OPTIMIZATION = 93,
    COMMUNITY_ARTICLE_AI_OPTIMIZATION_CREATE = 94,
    COMMUNITY_ARTICLE_AI_BRIEF_CREATE = 95,
    COMMUNITY_ARTICLE_AI_OPTIMIZATION_ERROR = 96,
    COMMUNITY_ARTICLE_AI_EXTRACT_TERM_ERROR = 97,
    COMMUNITY_SEO_AUDIT_CREATE = 98,
    COMMUNITY_SEO_PAGE_TRACKING = 99,
    COMMUNITY_ARTICLE_AI_PAGE_TRACKING_CREATE = 100,
    COMMUNITY_PARTNER_UPDATE_VERSION = 101,
    COMMUNITY_ONBOARDING_CREATE = 102,
    COMMUNITY_ONBOARDING_OPTIMIZATION_ANALYSIS = 103,
    COMMUNITY_ONBOARDING_OPTIMIZATION_ANALYSIS_ERROR = 104,
    COMMUNITY_ONBOARDING_CREATE_ANALYSIS = 105,
    COMMUNITY_ONBOARDING_CREATE_ANALYSIS_ERROR = 106,
    UPDATE_EMAILS_NOTIFY = 107,
    COMMUNITY_SEO_PAGE_TRACKING_EXPORT = 108,
    COMMUNITY_SEO_AUDIT_EXPORT = 109,
    COMMUNITY_CLUSTER_MANUALLY_CREATE = 110,
    COMMUNITY_PARTNER_CONNECTION_ERROR = 111,
    COMMUNITY_ARTICLE_AI_SERP_REFRESH = 112,
    REFERRAL_CREATED = 113,
    SITE_CREATED_WITH_REFERRAL = 114,
    REFERRAL_EARNING_RECEIVED = 115,
    HELP_CENTER_ASK_QUESTION = 116,
    COMMUNITY_IMAGES_CREATE = 117,
    COMMUNITY_IMAGES_OPTIMIZATION = 118,
    COMMUNITY_IMAGES_CHALLENGE_VALIDATE = 119,
    COMMUNITY_IMAGES_ALT_GENERATE = 120,
    COMMUNITY_IMAGES_PUBLISH = 121,
    COMMUNITY_IMAGES_PUBLISH_ERROR = 122,
    OFFER_CANCEL_ESTIMATE_MODE = 123,
    OFFER_CANCEL_ESTIMATE_TEXT = 124,
    OFFER_CANCEL_ESTIMATE_POPUP = 125,
    COMMUNITY_ARTICLE_ASK_AI = 126,
    COMMUNITY_KEYWORDS_SEARCH_ERROR = 127,
    COMMUNITY_IMAGES_CHALLENGE_EDIT = 128,
    COMMUNITY_IMAGES_CHALLENGE_EDIT_ERROR = 129,
    COMMUNITY_BACKLINK_EVALUATION_CREATE = 130,
    COMMUNITY_BACKLINKS_FETCH = 131,
    COMMUNITY_GSC_DISCONNECT_AUTO = 132,
    COMMUNITY_PARTNER_DISCONNECT_AUTO = 133,
    COMMUNITY_CALENDAR_REFRESH = 134,
    COMMUNITY_CALENDAR_UPDATE = 135,
    COMMUNITY_AUTOPILOT_SCHEDULED_POSTS_GENERATED = 136,
    COMMUNITY_COMPETITORS_RECALCULATE = 137,
    COMMUNITY_KEYWORD_RELEVANCE_EVALUATE = 138,
    COMMUNITY_SCHEDULED_POST_CREATE = 139,
    COMMUNITY_SCHEDULED_POST_UPDATE = 140,
    COMMUNITY_SCHEDULED_POST_DELETE = 141,
    COMMUNITY_COMPETITORS_DETAILS = 142,
    COMMUNITY_COMPETITORS_REFRESH_ANALYSES = 143,
    COMMUNITY_ARTICLE_AI_SERP_ERROR = 144,
    COMMUNITY_SCHEDULED_POST_RULES_UPDATE = 145,
    COMMUNITY_PARTNER_METAFIELD_CONFIG_UPDATE = 146,
    COMMUNITY_BACKLINK_CAMPAIGN_CREATE = 147,
    COMMUNITY_BACKLINK_CAMPAIGN_DELETE = 148,
    COMMUNITY_BACKLINK_CAMPAIGN_SELECT_PAGES = 149,
    COMMUNITY_BACKLINK_CAMPAIGN_SELECT_BACKLINKS = 150,
    COMMUNITY_BACKLINK_CAMPAIGN_ORDER_SUCCESS = 151,
    COMMUNITY_BACKLINK_CAMPAIGN_ORDER_ERROR = 152,
    SITE_CREDIT_DEBIT = 153,
    SITE_CREDIT_REFUND = 154,
    SITE_CREDIT_PURCHASE = 155,
    SITE_CREDIT_PURCHASE_QUOTE = 156,
    OFFER_CANCEL_ESTIMATE_CALLBACK = 157,
    COMMUNITY_LLM_PROMPT_CREATE = 158,
    COMMUNITY_LLM_PROMPT_UPDATE = 159,
    COMMUNITY_LLM_PROMPT_DELETE = 160,
    COMMUNITY_LLM_PROMPT_SUGGEST = 161,
    COMMUNITY_ARTICLE_FEEDBACK = 162,
    COMMUNITY_ARTICLE_FEEDBACK_STYLE_REFINE = 163,
    COMMUNITY_INDEXATION_CREDIT_PURCHASE = 164,
    COMMUNITY_INDEXATION_AGENT_UPDATE = 165,
    COMMUNITY_INDEXATION_ONBOARDING = 166,
    COMMUNITY_ARTICLE_SCHEDULED = 167,
    PROFILE_TYPE_UPDATE = 168,
    COMMUNITY_BUSINESS_CONNECTED = 169,
    COMMUNITY_BUSINESS_DISCONNECT = 170,
    COMMUNITY_BUSINESS_NO_PERMISSIONS = 171,
    COMMUNITY_BUSINESS_NO_LOCATION = 172,
    COMMUNITY_BUSINESS_UPDATE = 173,
    COMMUNITY_ARTICLE_AI_CHAT = 174,
    COMMUNITY_ARTICLE_AI_CHAT_ERROR = 175,
    COMMUNITY_CTA_GENERATE = 176,
    COMMUNITY_CTA_CREATE = 177,
    COMMUNITY_CTA_UPDATE = 178,
    COMMUNITY_START_BRAND = 179,
    COMMUNITY_START_BLOG = 180,
    COMMUNITY_START_SITE = 181,
    COMMUNITY_START_OPTIMIZATION = 182,
    COMMUNITY_START_PUBLISH_BLOCKED = 183,
    COMMUNITY_START_GSC = 184,
    COMMUNITY_START_DONE = 185,
    COMMUNITY_KNOWLEDGE_RESSOURCE_UPDATE = 186,
    COMMUNITY_AGENT_CHAT = 187,
    OFFER_EXPORT_BLOCKED = 188,
    OFFER_MODAL_OPEN = 189,
    OFFER_PLAN_SELECT = 190
}